import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AddGuardianTypeComponent } from "./add-guardian-type/add-guardian-type.component";
import { EditGuardianTypeComponent } from "./edit-guardian-type/edit-guardian-type.component";
import { DataService_GuardianTypeSetup } from "./shared/data.service";

@Component({
	selector: "app-guardian-type-setup",
	templateUrl: "./guardian-type-setup.component.html",
	styleUrls: ["./guardian-type-setup.component.css"],
})
export class GuardianTypeSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private GuardianTypeSetupService: DataService_GuardianTypeSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	ToggleText: any = "Deactivate Type";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGuardianType: any;
	lstGuardianType: any = [];

	//Filter lists
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];
	lstUsedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "RelationshipDesc", header: "Description" },
		{ field: "RelationshipCD", header: "Code" },
		{ field: "ActiveDesc", header: "Active" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'UsedByDesc', header: 'Used By' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadGuardianType();
			},
			(error) => {}
		);
	}

	loadGuardianType() {
		this.loading = true;

		var result = this.GuardianTypeSetupService.LoadGuardianType(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGuardianType = response;

				for (var i = 0; i < this.lstGuardianType.length; i++) {
					var next = this.lstGuardianType[i];

					next.ActiveDesc = next.Active == 1 ? "Yes" : "No";
					next.UsedByDesc = next.SchoolID > 0 ? "This School Only" : "District";
				}

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstGuardianType.map((item: any) => item.ActiveDesc))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstGuardianType.map((item: any) => item.DefinedByDesc))).sort();
				this.lstUsedByDesc = Array.from(new Set(this.lstGuardianType.map((item: any) => item.UsedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGuardianType();

		this.onRowUnselect(null);
	}

	//Custom Button Methods
	onAddType() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddGuardianTypeComponent, {
			header: "Add Guardian Relationship",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuardianType();
			}
		});
	}

	onEditType() {
		this.errorMessage = "";

		if (this.SelectedGuardianType == undefined) {
			this.errorMessage = "Select a guardian type to edit";
			return;
		}

		if (this.SelectedGuardianType.DefinedByDesc == "System" || this.SelectedGuardianType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot edit system-defined or import-defined guardian types";
			return;
		}

		if (this.SelectedGuardianType.DefinedByDesc == "District User" && this.user.UserLevelID == 3) {
			this.errorMessage = "School users cannot edit district-level guardian types";
			return;
		}

		var ref = this.dialogService.open(EditGuardianTypeComponent, {
			header: "Edit Guardian Relationship",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				SelectedGuardianType: this.SelectedGuardianType,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuardianType();
			}
		});
	}

	onToggleType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGuardianType == undefined) {
			this.errorMessage = "Select a guardian type to delete";
			return;
		}

		if (this.SelectedGuardianType.DefinedByDesc == "System" || this.SelectedGuardianType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot delete system-defined or import-defined guardian types";
			return;
		}

		if (this.SelectedGuardianType.DefinedByDesc == "District User" && this.user.UserLevelID == 3) {
			this.errorMessage = "School users cannot delete district-level guardian types";
			return;
		}

		//Call SP
		var changeTo = this.SelectedGuardianType.Active == 1 ? 0 : 1;

		var result = this.GuardianTypeSetupService.ParentRelationshipSetActive(this.SelectedGuardianType.RelationshipID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGuardianType();

					this.onRowUnselect(null);
				} else {
					var ToggleErrorMSG = "Could not ";
					ToggleErrorMSG += changeTo == 1 ? "activate " : "deactivate ";
					ToggleErrorMSG += "the guardian type";

					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: ToggleErrorMSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadGuardianType();

		this.onRowUnselect(null);
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedGuardianType = val.data;

		this.ToggleText = "Deactivate Type";
		if (this.SelectedGuardianType.Active == 0) {
			this.ToggleText = "Activate Type";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.ToggleText = "Deactivate Type";

		this.SelectedGuardianType = null;
	}
	onRowDblClick(GuardianType) {
		this.errorMessage = "";

		this.SelectedGuardianType = GuardianType;

		this.ToggleText = "Deactivate Type";
		if (this.SelectedGuardianType.Active == 0) {
			this.ToggleText = "Activate Type";
		}

		this.onEditType();
	}
	////////////////////////////////////////////
}
